class CheckoutForm extends HTMLFormElement {
  constructor() {
    super();

    this.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    const termsAndConditionsEl = this.querySelector('[data-terms-and-conditions-checkbox]');
    const isTermsAndConditionsAccepted = termsAndConditionsEl.checked;
    if (!isTermsAndConditionsAccepted) {
      event.preventDefault();
      this.validateTermsAndConditions();
    }
  }

  validateTermsAndConditions() {
    const termsAndConditionsEl = this.querySelector('[data-terms-and-conditions-checkbox]');
    const labelEl = termsAndConditionsEl.closest('label');

    termsAndConditionsEl.style.borderColor = 'red';
    labelEl.style.color = 'red';
  }
}

window.customElements.define('checkout-form', CheckoutForm, { extends: 'form' });

class ValidateCheckbox extends HTMLLabelElement {
  constructor() {
    super();

    this.addEventListener('change', (() => {
      this.style.color = null;
      this.querySelector('input').style.borderColor = null;
    }).bind(this));
  }
}

window.customElements.define('validate-checkbox', ValidateCheckbox, { extends: 'label' });